import { RoomReservationApiRoomReservationListRequest, RoomReservationApiRoomReservationUpdateStatusRequest, RoomReservationApiRoomReservationCreateRequest } from '../../openapi/api'
import appApiClient from './appApiClient'
import useBaseMutation from './useBaseMutation';
import useBaseQuery from './useBaseQuery';

export type RoomReservation = {
  id: string;
  roomId: string;
  title: string;
  startTime: string;
  endTime: string;
  password: string;
  status: 'active' | 'cancelled';
  roomName: string;
}

export const useRoomReservationListQuery = (req: RoomReservationApiRoomReservationListRequest = {}) => useBaseQuery({
    queryKey: ['roomReservationList', req],
    queryFn: (config) => appApiClient.roomReservationApi.roomReservationList(req, config),
  });

export const useCreateRoomReservationMutation = () => useBaseMutation({
    mutationFn: (req: RoomReservationApiRoomReservationCreateRequest, config) =>
      appApiClient.roomReservationApi.roomReservationCreate(req, config),
  });

export const useUpdateRoomReservationStatusMutation = () => useBaseMutation({
    mutationFn: (req: RoomReservationApiRoomReservationUpdateStatusRequest, config) =>
      appApiClient.roomReservationApi.roomReservationUpdateStatus(req, config),
  }); 